module.exports = __webpack_public_path__ + "img/new_fans.1cf19409.png";